/* ============================================================
   SENTINEL PDP — Front-end behavior
   product.sentinel template
   Handles: gallery thumbs, sticky ATC bar, qty selector, desc toggle,
            smooth-scroll anchors, Judge.me fallback hide, simple bundle stub.
   File 04 will replace/extend the bundle calculator's add-to-cart logic.
   ============================================================ */

(function () {
  'use strict';

  // Run on the welded Sentinel PDP (body class template-product-sentinel) AND the
  // electric-fence PDP (template-product-sentinel-electric). classList.contains is
  // an exact-token match, so substring-match the className to cover both suffixes.
  if (document.body.className.indexOf('template-product-sentinel') === -1) return;
  if (window.__spdpInit) return;
  window.__spdpInit = true;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.from((root || document).querySelectorAll(sel)); };

  /* ----- Gallery thumb navigation ----- */
  function initGallery() {
    var media = $$('.spdp-hero__media');
    var thumbs = $$('.spdp-hero__thumb');
    if (media.length <= 1 || thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.dataset.spdpThumbIndex, 10);
        media.forEach(function (m) {
          var mi = parseInt(m.dataset.spdpMediaIndex, 10);
          m.classList.toggle('spdp-hero__media--active', mi === idx);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('spdp-hero__thumb--active', t === thumb);
        });
      });
    });
  }

  /* ----- Quantity selector +/- ----- */
  function initQty() {
    var qtyInput = $('[data-spdp-qty-input]');
    var qtyCount = $('[data-spdp-qty-count]');
    var minusBtn = $('[data-spdp-qty-minus]');
    var plusBtn = $('[data-spdp-qty-plus]');
    if (!qtyInput || !qtyCount || !minusBtn || !plusBtn) return;

    function update(delta) {
      var current = parseInt(qtyInput.value, 10) || 1;
      var next = Math.max(1, current + delta);
      qtyInput.value = next;
      qtyCount.textContent = next;
    }
    minusBtn.addEventListener('click', function () { update(-1); });
    plusBtn.addEventListener('click', function () { update(1); });
  }

  /* ----- Description Voir plus / Voir moins ----- */
  function initDescToggle() {
    var wrap = $('[data-spdp-desc]');
    var btn = $('[data-spdp-desc-toggle]');
    var text = $('[data-spdp-desc-text]');
    if (!wrap || !btn || !text) return;

    // Hide toggle if text doesn't actually clamp
    requestAnimationFrame(function () {
      if (text.scrollHeight <= text.clientHeight + 2) {
        btn.style.display = 'none';
      }
    });

    btn.addEventListener('click', function () {
      var expanded = wrap.hasAttribute('data-spdp-desc-expanded');
      if (expanded) {
        wrap.removeAttribute('data-spdp-desc-expanded');
        btn.textContent = 'Voir plus';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        wrap.setAttribute('data-spdp-desc-expanded', '');
        btn.textContent = 'Voir moins';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ----- Smooth-scroll anchors ----- */
  function initSmoothScroll() {
    $$('[data-spdp-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        var offset = target.getBoundingClientRect().top + window.pageYOffset - 16;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      });
    });
  }

  /* ----- Sticky ATC bar visibility (mobile only) ----- */
  function initStickyATC() {
    var bar = $('[data-spdp-sticky-atc]');
    var atc = $('[data-spdp-atc]');
    if (!bar || !atc) return;

    /* Hoist the bar to <body> so it escapes any ancestor stacking context.
       Section wrappers, scroll-reveal transforms, and CSS containment can
       all trap a `position: fixed` child — moving it out of the section
       guarantees z-index 9999 wins against any later content. */
    if (bar.parentNode !== document.body) {
      document.body.appendChild(bar);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Show the bar when the primary ATC button is OUT of view
        bar.dataset.visible = entry.isIntersecting ? 'false' : 'true';
        bar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });

    observer.observe(atc);

    // Sticky button mirrors the main ATC button so it routes through the
    // same Ajax interceptor (clicking the primary ATC dispatches the form
    // submit event which initATCForm() handles).
    var stickyBtn = $('[data-spdp-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var atcBtn = $('[data-spdp-atc]');
        if (atcBtn && !atcBtn.disabled) atcBtn.click();
      });
    }

    // Mirror current price into the sticky bar
    var price = $('[data-spdp-price]');
    var stickyPrice = $('[data-spdp-sticky-price]');
    if (price && stickyPrice) {
      var sync = function () { stickyPrice.textContent = price.textContent.trim(); };
      sync();
      var mo = new MutationObserver(sync);
      mo.observe(price, { childList: true, characterData: true, subtree: true });
    }

    /* Visual-viewport tracking — on mobile Safari + Chrome, the URL bar
       overlays the bottom of the layout viewport. `position: fixed; bottom: 0`
       anchors to the layout viewport, so when the URL bar collapses on
       scroll-down the bar appears to "hover" above where the URL bar used
       to be. We compute the actual overlap and offset the bar so it always
       sits flush against the visual viewport bottom. */
    if ('visualViewport' in window) {
      var rafId = null;
      var updateBottomOffset = function () {
        rafId = null;
        var vv = window.visualViewport;
        var overlap = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
        bar.style.setProperty('--spdp-sticky-bottom-offset', overlap + 'px');
      };
      var schedule = function () {
        if (rafId) return;
        rafId = requestAnimationFrame(updateBottomOffset);
      };
      window.visualViewport.addEventListener('resize', schedule);
      window.visualViewport.addEventListener('scroll', schedule);
      updateBottomOffset();
    }
  }

  /* ----- Judge.me preview badge: hide fallback once it mounts ----- */
  function initJudgemeFallback() {
    var fallback = $('[data-spdp-rating-fallback]');
    var badge = $('.spdp-hero__rating .jdgm-preview-badge');
    if (!fallback || !badge) return;

    var check = function () {
      // Judge.me injects child elements when content loads
      if (badge.childElementCount > 0 || badge.textContent.trim() !== '') {
        fallback.style.display = 'none';
        return true;
      }
      return false;
    };

    if (check()) return;
    var observer = new MutationObserver(function () { check(); });
    observer.observe(badge, { childList: true, subtree: true, characterData: true });
    // Stop observing after 4 seconds either way
    setTimeout(function () { observer.disconnect(); }, 4000);
  }

  /* ----- Variant pill selector -----
     Click a Format pill → update URL, hidden variant input, price block,
     free-delivery callout, stock copy, sticky ATC, specs cells, and
     dispatch 'variant:change' so the bundle module re-renders. */
  function initVariantPills() {
    var pills = $$('[data-spdp-variant]');
    if (pills.length === 0) return;

    var variantInput = $('[data-spdp-variant-id]');
    var priceEl = $('[data-spdp-price]');
    var stickyPriceEl = $('[data-spdp-sticky-price]');
    var stickyVariantEl = $('[data-spdp-sticky-variant]');
    var atcBtn = $('[data-spdp-atc]');
    var stickyAtcBtn = $('[data-spdp-sticky-atc-btn]');
    var deliveryCallout = $('[data-spdp-hero-delivery]');
    var stockWrap = $('[data-spdp-stock]');
    var specsHeight = $('[data-spdp-specs-height]');
    var specsLength = $('[data-spdp-specs-length]');
    var specsWeight = $('[data-spdp-specs-weight]');

    var FREE_DELIVERY_CENTS = 9500;

    function formatMoney(cents) {
      var dollars = (cents / 100).toFixed(2);
      return dollars + ' $';
    }

    /* Only the OOS state surfaces here. Per-store stock counts live in
       fg-store-inventory below; weight-based handling is intentionally
       not surfaced (friction without conversion value at browse time). */
    function availabilityCopy(weight, inventoryQty, available) {
      if (!available) return { text: 'Bientôt de retour', cls: 'spdp-hero__stock--out' };
      return null;
    }

    function applyVariant(pill) {
      var variantId = pill.dataset.spdpVariant;
      var priceCents = parseInt(pill.dataset.spdpVariantPrice, 10) || 0;
      var compareCents = parseInt(pill.dataset.spdpVariantCompareprice, 10) || 0;
      var weight = parseFloat(pill.dataset.spdpVariantWeight) || 0;
      var inventoryQty = parseInt(pill.dataset.spdpVariantInventory, 10) || 0;
      var available = pill.dataset.spdpVariantAvailable === 'true';

      // Active pill state
      pills.forEach(function (p) { p.classList.toggle('spdp-hero__variant-pill--active', p === pill); });

      // URL update (no reload)
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* IE fallback: ignore */ }

      // Form variant id
      if (variantInput) variantInput.value = variantId;

      // Price (hero price block + sticky bar + price baked into main ATC label)
      if (priceEl) priceEl.textContent = formatMoney(priceCents);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(priceCents);
      var atcPriceEl = $('[data-spdp-atc-price]');
      if (atcPriceEl) atcPriceEl.textContent = formatMoney(priceCents);

      // Sticky variant indicator line ("Format · 4'x100'")
      if (stickyVariantEl) {
        var formatLabel = pill.querySelector('.spdp-hero__pill-format');
        if (formatLabel) {
          stickyVariantEl.textContent = 'Format · ' + formatLabel.textContent.trim();
        }
      }

      // Free delivery callout — qualified ("incluse") vs almost ("Encore X $...")
      if (deliveryCallout) {
        var qualified = priceCents >= FREE_DELIVERY_CENTS;
        var remaining = FREE_DELIVERY_CENTS - priceCents;
        deliveryCallout.classList.toggle('spdp-hero__delivery-callout--qualified', qualified);
        var iconQualified = deliveryCallout.querySelector('[data-spdp-delivery-icon-qualified]');
        var iconAlmost = deliveryCallout.querySelector('[data-spdp-delivery-icon-almost]');
        if (iconQualified) iconQualified.style.display = qualified ? '' : 'none';
        if (iconAlmost) iconAlmost.style.display = qualified ? 'none' : '';
        var deliveryText = deliveryCallout.querySelector('[data-spdp-hero-delivery-text]');
        if (deliveryText) {
          if (qualified) {
            deliveryText.innerHTML = 'Livraison locale gratuite incluse<sup>*</sup>';
          } else {
            deliveryText.innerHTML = 'Encore <strong>' + formatMoney(remaining) + '</strong> pour la livraison locale gratuite<sup>*</sup>';
          }
        }
      }

      // ATC button state + label
      [atcBtn, stickyAtcBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        if (btn === atcBtn) {
          btn.textContent = available ? 'Ajouter au panier' : 'Rupture de stock';
        } else if (btn === stickyAtcBtn) {
          btn.textContent = available ? 'Ajouter' : 'Rupture';
        }
      });

      // Stock copy
      if (stockWrap) {
        var copy = availabilityCopy(weight, inventoryQty, available);
        stockWrap.innerHTML = copy
          ? '<p class="spdp-hero__stock ' + copy.cls + '">' + copy.text + '</p>'
          : '';
      }

      // Specs cells
      if (specsHeight) specsHeight.textContent = (pill.dataset.spdpVariantHeight || '') + ' pi';
      if (specsLength) specsLength.textContent = (pill.dataset.spdpVariantLength || '') + ' pi';
      if (specsWeight) specsWeight.textContent = weight + ' kg';

      // Notify everyone else (bundle module, analytics)
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          variant_id: variantId,
          sku: pill.dataset.spdpVariantSku,
          price_cents: priceCents,
          weight_kg: weight,
          inventory_quantity: inventoryQty,
          available: available,
          height_ft: pill.dataset.spdpVariantHeight,
          length_ft: pill.dataset.spdpVariantLength
        }
      }));
    }

    pills.forEach(function (pill) {
      if (pill.hasAttribute('data-spdp-variant-unavailable')) {
        pill.addEventListener('click', function (e) { e.preventDefault(); });
        return;
      }
      pill.addEventListener('click', function () { applyVariant(pill); });
    });
  }

  /* ----- Use-case "Format recommandé" CTAs -----
     Each Module A bullet has a button with data-spdp-format. Click finds
     the matching variant pill by Format text, scrolls to the buy box, and
     triggers the pill click (which dispatches variant:change). Always
     scrolls to the buy box even if the exact format isn't matched, so the
     button never feels broken on edge-case products. */
  function initUseCaseCTAs() {
    $$('[data-spdp-uc-cta]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var format = btn.dataset.spdpFormat;
        var pills = $$('[data-spdp-variant]');
        var match = pills.find(function (p) {
          var label = p.querySelector('.spdp-hero__pill-format');
          return label && label.textContent.trim() === format;
        });
        if (match) match.click();
        var purchaseCol = $('.spdp-hero__purchase');
        if (purchaseCol) {
          purchaseCol.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ----- ATC form: open cart drawer instead of redirecting to /cart -----
     Matches the FGE canonical pattern from fg-fastbuy.js + terrain-pdp.js:
       - form-urlencoded body (not JSON)
       - dispatch cart:updated + cart:refresh after add
       - refresh /cart.js for the theme's drawer-rebuild logic
       - synthesize a click on #cart-icon-bubble to pop the drawer
         (Stockmart-base theme convention; cart:open events alone don't
         open this theme's drawer).                                       */
  function buildFormBody(pairs) {
    var out = [];
    for (var i = 0; i < pairs.length; i++) {
      out.push(encodeURIComponent(pairs[i][0]) + '=' + encodeURIComponent(pairs[i][1]));
    }
    return out.join('&');
  }

  function openCartDrawer() {
    /* Canonical FGE pattern (moulee-pdp / fg-fastbuy): fetch the current
       page with ?sections=cart-drawer,cart-icon-bubble to get freshly
       server-rendered drawer HTML, then call cartDrawer.renderContents()
       which swaps the DOM and opens the drawer in one step. Clicking the
       header bubble alone only opens stale HTML and won't show new items. */
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
      var cartLink = document.getElementById('cart-icon-bubble');
      if (cartLink) cartLink.click();
      return Promise.resolve();
    }
    if (cartDrawer.classList.contains('is-empty')) {
      cartDrawer.classList.remove('is-empty');
    }
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        cartDrawer.renderContents({ sections: sections });
      })
      .catch(function (err) {
        console.error('[Sentinel PDP] drawer render failed', err);
        var cartLink = document.getElementById('cart-icon-bubble');
        if (cartLink) cartLink.click();
      });
  }

  function initATCForm() {
    var form = $('[data-spdp-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantInput = $('[data-spdp-variant-id]');
      var qtyInput = $('[data-spdp-qty-input]');
      var atcBtn = $('[data-spdp-atc]');
      if (!variantInput || !variantInput.value) return;
      var idRaw = String(parseInt(variantInput.value, 10));
      if (!idRaw || idRaw === 'NaN') return;
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;

      var originalLabel = atcBtn ? atcBtn.textContent : '';
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Ajout en cours...';
      }

      var body = buildFormBody([
        ['id', idRaw],
        ['quantity', String(qty)]
      ]);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: body
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw (err && err.description) ? err.description : 'Erreur : ajout impossible.';
            });
          }
          return res.json();
        })
        .then(function () {
          /* IMPORTANT: render the drawer FIRST, then dispatch cart:refresh.
             The bundle upsell (sentinel-bundle.js) injects its suggestion
             into .drawer__cart-items-wrapper on cart:refresh. If we
             dispatched before renderContents, the upsell would land in the
             stale DOM and be wiped when renderContents replaces innerHTML.
             Awaiting openCartDrawer guarantees the fresh drawer DOM exists
             when the suggestion logic runs. */
          return Promise.resolve(openCartDrawer()).then(function () {
            try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
            try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
            try { window.dispatchEvent(new Event('cart:refresh')); } catch (e) {}
          });
        })
        .then(function () {
          if (atcBtn) {
            atcBtn.textContent = 'Ajouté ✓';
            atcBtn.classList.add('is-added');
            setTimeout(function () {
              atcBtn.disabled = false;
              atcBtn.textContent = originalLabel;
              atcBtn.classList.remove('is-added');
            }, 2200);
          }
        })
        .catch(function (msg) {
          console.error('[Sentinel ATC]', msg);
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.textContent = 'Erreur, réessayez';
            setTimeout(function () { atcBtn.textContent = originalLabel; }, 2500);
          }
        });
    });
  }

  /* Bundle calculator + cart drawer suggestion live in sentinel-bundle.js
     (loaded by sentinel-pdp-bundle.liquid). Kept separate so the bundle
     logic can later go site-wide without dragging the PDP behavior along. */

  /* ----- Scroll-reveal -----
     Below-fold sections fade in on entering the viewport. Mirror's
     TERRAIN's .tpdp-reveal pattern. Hero stays static (it's the LCP).
     JS-driven so a JS-disabled visitor sees content normally. */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sections = $$('.spdp-section');
    if (sections.length === 0) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('spdp-section--revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
    sections.forEach(function (s) {
      if (s.classList.contains('spdp-hero')) return; /* LCP — don't animate */
      s.classList.add('spdp-section--will-reveal');
      observer.observe(s);
    });
  }

  /* ----- Lightbox / zoom -----
     Click the active gallery image → opens an overlay with the full-size
     image. Arrow keys + prev/next buttons cycle. Escape, X, or backdrop
     click closes. Locks body scroll while open. */
  function initLightbox() {
    var lightbox = $('[data-spdp-lightbox]');
    if (!lightbox) return;
    var img = $('[data-spdp-lightbox-img]', lightbox);
    var counter = $('[data-spdp-lightbox-counter]', lightbox);
    var closeBtn = $('[data-spdp-lightbox-close]', lightbox);
    var prevBtn = $('[data-spdp-lightbox-prev]', lightbox);
    var nextBtn = $('[data-spdp-lightbox-next]', lightbox);

    var media = $$('.spdp-hero__media');
    if (media.length === 0 || !img) return;

    var currentIndex = 0;
    var lastFocus = null;

    function srcAt(idx) {
      var m = media[idx];
      if (!m) return null;
      var el = m.querySelector('img');
      return el ? (el.currentSrc || el.src) : null;
    }
    function altAt(idx) {
      var m = media[idx];
      var el = m && m.querySelector('img');
      return el ? (el.alt || '') : '';
    }

    function render() {
      var src = srcAt(currentIndex);
      if (!src) return;
      img.src = src;
      img.alt = altAt(currentIndex);
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + media.length;
    }

    function open(idx) {
      currentIndex = idx;
      lastFocus = document.activeElement;
      render();
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lightbox.hidden = true;
      img.src = '';
      document.body.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function step(delta) {
      currentIndex = (currentIndex + delta + media.length) % media.length;
      render();
    }

    media.forEach(function (m, idx) {
      m.style.cursor = 'zoom-in';
      m.addEventListener('click', function () { open(idx); });
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    /* Backdrop click only — ignore image / button clicks */
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });
  }

  /* ----- Inline kit-tile (below ATC) -----
     Server-renders for the initial variant in snippets/sentinel-kit-tile.liquid.
     On variant:change, read the bundle module's by_variant_id JSON blob and
     update the tile's tpost qty, spec line, pricing, and combined total.
     The "Ajouter rouleau + kit" button delegates to [data-spdp-bundle-add]
     so the existing bundle ATC handler does cart + discount + drawer. */
  function initKitTile() {
    var tile = $('[data-spdp-kit-tile]');
    if (!tile) return;

    // Wire kit ATC -> existing bundle module ATC (no duplicate cart logic)
    var kitAddBtn = $('[data-spdp-kit-add]', tile);
    if (kitAddBtn) {
      kitAddBtn.addEventListener('click', function () {
        var bundleBtn = $('[data-spdp-bundle-add]');
        if (bundleBtn && !bundleBtn.disabled) {
          bundleBtn.click();
          // Brief inline feedback so users see the click registered.
          var originalLabel = kitAddBtn.innerHTML;
          kitAddBtn.disabled = true;
          kitAddBtn.textContent = 'Ajout en cours...';
          setTimeout(function () {
            kitAddBtn.disabled = false;
            kitAddBtn.innerHTML = originalLabel;
          }, 3000);
        }
      });
    }

    function formatKitMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' $';
    }

    function readBundleData() {
      var node = $('[data-spdp-bundle-data]');
      if (!node) return null;
      try { return JSON.parse(node.textContent); } catch (e) { return null; }
    }

    function updateTile(variantId) {
      var bundleData = readBundleData();
      if (!bundleData || !bundleData.by_variant_id) return;
      var vd = bundleData.by_variant_id[String(variantId)];
      if (!vd) return;

      var components = (vd.components || []).filter(function (c) {
        return c.variant_id && c.available;
      });
      var tpostComp = components.filter(function (c) { return c.role === 'tpost'; })[0];

      // T-post qty appears in both the thumbnail badge AND the spec line.
      if (tpostComp) {
        var qtyBadge = tile.querySelector('[data-spdp-kit-tpost-qty]');
        var specCount = tile.querySelector('[data-spdp-kit-tpost-count]');
        if (qtyBadge) qtyBadge.textContent = '×' + tpostComp.quantity;
        if (specCount) specCount.textContent = tpostComp.quantity;
      }

      // Pricing
      var subtotal = components.reduce(function (sum, c) {
        return sum + (c.price_cents * c.quantity);
      }, 0);
      var discountPct = vd.discount_percent || 0;
      var savings = Math.floor(subtotal * discountPct / 100);
      var net = subtotal - savings;
      var combined = (vd.price_cents || 0) + net;

      var subtotalEl = $('[data-spdp-kit-subtotal]', tile);
      var netEl = $('[data-spdp-kit-net]', tile);
      var savingsEl = $('[data-spdp-kit-savings]', tile);
      var savingsRow = $('[data-spdp-kit-savings-row]', tile);
      var combinedEl = $('[data-spdp-kit-combined]', tile);
      var discountBadge = $('[data-spdp-kit-discount-badge]', tile);
      var discountPctEl = $('[data-spdp-kit-discount-pct]', tile);

      var hasDiscount = discountPct > 0 && savings > 0;

      if (subtotalEl) {
        subtotalEl.textContent = formatKitMoney(subtotal);
        subtotalEl.style.display = hasDiscount ? '' : 'none';
      }
      if (savingsEl) savingsEl.textContent = formatKitMoney(savings);
      if (savingsRow) savingsRow.style.display = hasDiscount ? '' : 'none';
      if (discountPctEl) discountPctEl.textContent = discountPct;
      if (discountBadge) discountBadge.style.display = hasDiscount ? '' : 'none';
      if (netEl) netEl.textContent = formatKitMoney(net);
      if (combinedEl) combinedEl.textContent = formatKitMoney(combined);
    }

    document.addEventListener('variant:change', function (e) {
      var newVariantId = e.detail && e.detail.variant_id;
      if (newVariantId) updateTile(newVariantId);
    });
  }

  /* ----- Init ----- */
  /* ----- EF kit add-to-cart: route through the Ajax cart-drawer pattern -----
     The "Composez votre système" tile + section use plain <form action="/cart/add">
     so they still work without JS; here we intercept them and open the cart
     drawer instead of redirecting to /cart, reusing openCartDrawer()/buildFormBody(). */
  function initEFKitForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('.spdp-ef-tile__add-form, .spdp-ef-kit__add-form')) return;
      e.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      var id = String(parseInt(idInput.value, 10));
      if (!id || id === 'NaN') return;
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: buildFormBody([['id', id], ['quantity', '1']])
      })
        .then(function (res) {
          if (!res.ok) { return res.json().then(function (err) { throw (err && err.description) ? err.description : 'Erreur'; }); }
          return res.json();
        })
        .then(function () {
          return Promise.resolve(openCartDrawer()).then(function () {
            try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e2) {}
            try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e2) {}
            try { window.dispatchEvent(new Event('cart:refresh')); } catch (e2) {}
          });
        })
        .then(function () {
          if (btn) { btn.textContent = '✓'; setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1800); }
        })
        .catch(function (msg) {
          console.error('[Sentinel EF kit]', msg);
          if (btn) { btn.disabled = false; btn.textContent = original; }
        });
    });
  }

  function init() {
    initGallery();
    initQty();
    initDescToggle();
    initSmoothScroll();
    initStickyATC();
    initJudgemeFallback();
    initVariantPills();
    initUseCaseCTAs();
    initATCForm();
    initLightbox();
    initScrollReveal();
    initKitTile();
    initEFKitForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
